<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main" class="container">
        <div class="text-center py-md-5 px-md-4 py-3">
          <h1 class="text-uppercase text-center mb-3 page-heading">
            Save on activewear that helps move you
          </h1>
          <p class="page-subheader">
            Get a $10 digital reward for activewear when you buy 2 boxes of Special K<sup>®</sup> cereals. 
          </p>
        </div>
        <h2 class="text-center mb-5">How To Participate</h2>

        <div class="row text-center mb-5 d-flex justify-content-center htsect">
          <div class="col-md-6 col-lg-4">
            <div class="">
              <img
                src="https://snippcheck.blob.core.windows.net/files/wkkc_special_k_athletic_2007824/shop.png"
                alt="Shop"
                class="img-fluid mb-3"
              />
              <h4>BUY</h4>
              <p>
                Buy any two (2) participating Kellogg’s<sup>®</sup> Special K<sup>®</sup> cereals in one transaction between 11/11/24 and 4/30/25. 
              </p>
            </div>
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="">
              <img
                src="https://snippcheck.blob.core.windows.net/files/wkkc_special_k_athletic_2007824/snap.png"
                alt="Snap"
                class="img-fluid mb-3"
              />
              <h4>UPLOAD</h4>
              <p>
                Upload your receipt with qualifying purchase(s). Receipts must be submitted within 30 days of purchase, no later than 5/30/25. 
              </p>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="">
              <img
                src="https://snippcheck.blob.core.windows.net/files/wkkc_special_k_athletic_2007824/submit.png"
                alt="Send"
                class="img-fluid mb-3"
              />
              <h4>GET</h4>
              <p>
                Get one (1) $10 reward digitally good toward activewear. Get a reply containing a code and link to receive your $10 reward to use online. Reward must be claimed by 6/16/25. Limit 5 per customer. 
              </p>
            </div>
          </div>
        </div>
        <hr />
        <div class="text-center readytosubmit mt-5 mb-5">
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-sm-12 text-sm-center">
            <div v-if="!showComponent" id="abc"> 
              <h2 class="">Ready to Submit?</h2>
              <p class="mt-3">
                Click GET STARTED below to upload your receipt and receive your digital reward. 
              </p>
            </div>
              <div class="col-sm-12">
                <div class="mb-5">
                  <p><router-link to="/Upload" class="btn btn-link">Get Started</router-link></p>            
          
                  <!-- <section class="wrapper" v-if="showComponent">
                    <component
                    v-if="showComponent"
                    :is="WidgetComponent"
                    campaign-id="e796d797-3d7b-41cc-bcfa-24613a3455d5"
                  ></component>
                  </section> -->
                </div>
              </div>
              <a href="http://snipp.us/!cumUv" class="anc-link" target="_blank"
                >Click here to view all participating cereal products. </a
              ><br />
            </div>
          </div>
        </div>
        <hr />
        <div class="pt-4 pb-4 mb-5">
        <h3>Details & Disclaimers</h3>
       
       <p>Abbreviated Terms and Conditions. Internet access required. Begins 11/11/24 and ends 4/30/25. Open to legal 
        residents of US, DC, US Territories and Caribbean, 18+. Subject to complete terms and conditions at  <a title="http://www.skactivewear.com" href="http://www.skactivewear.com" target="_blank">www.skactivewear.com</a>;
         complete list of participating products also found  <a href="http://snipp.us/!cumUv" target="_blank">here</a>. Participating products must be purchased between 11/11/24 and 
         4/30/25. Receipts must be uploaded at  <a title="http://www.skactivewear.com" href="http://www.skactivewear.com" target="_blank">www.skactivewear.com</a>. <b>Message and data rates may apply.</b> Receipts must be submitted 
         by 5/30/25, and reward must be claimed by 6/16/25. Void where prohibited. Sponsor: WK Kellogg Co, One Kellogg Square, 
         North Tower, Battle Creek, MI  49016.</p>
<p>© {{ new Date().getFullYear() }} WK Kellogg Co</p>
         </div>
      </main>
    </div>
  </div>
</template>
<script>


export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
    };
  }
};
</script>
